// extracted by mini-css-extract-plugin
export default {"expandInfo":"FormularioFicha_expandInfo__lLq1S","btnSemIndex":"FormularioFicha_btnSemIndex__mccxe"};